import React from 'react';
import { FormattedDate } from 'react-intl';
import { Tooltip } from '../Tooltip/index.js';
import { Body } from '../Typography/index.js';
import { DistanceToNow } from './DistanceToNow.js';
/**
 * Renders a relative timestamp with the absolute time in a tooltip.
 *
 * The base formatting, `formatOptions`, supports the same options as [Intl.RelativeTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/RelativeTimeFormat#parameters).
 *
 * The tooltip formatting, `tooltipFormatOptions`, supports the same options as [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#parameters).
 *
 * ### Import Guide
 *
 * ```jsx
 * import { RelativeTimestamp } from "@panwds/react-ui";
 * ```
 */
export function RelativeTimestamp({ formatOptions, tooltipFormatOptions, value, ...passThrough }) {
    return (React.createElement(Tooltip, { label: React.createElement(FormattedDate, { value: value, ...tooltipFormatOptions }) },
        React.createElement("span", null,
            React.createElement(Body, { as: "span", ...passThrough },
                React.createElement(DistanceToNow, { value: value, ...formatOptions })))));
}
//# sourceMappingURL=RelativeTimestamp.js.map